(function () {
  const catalogSortFallback = document.querySelector('[data-catalog-sort-default]');
  if (catalogSortFallback) {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('sort_by', catalogSortFallback.dataset.catalogSortDefault);
    window.location.replace(`${window.location.pathname}?${searchParams}${window.location.hash}`);
    return;
  }

  const FacetFiltersFormClass = window.customElements && window.customElements.get('facet-filters-form');
  if (!FacetFiltersFormClass || typeof FacetFiltersFormClass.prototype.createSearchParams !== 'function') {
    console.warn('custom-facets: facet-filters-form is not registered; range filters are disabled.');
    return;
  }

  const RANGE_TYPES = ['length', 'width', 'weight', 'carat'];
  const RANGE_STATE_PREFIX = 'tf_range_';
  const originalCreateSearchParams = FacetFiltersFormClass.prototype.createSearchParams;

  function rangeStateKey(type, boundary) {
    return `${RANGE_STATE_PREFIX}${type}_${boundary}`;
  }

  function rangeDefinition(form, type) {
    const definitions = [...form.querySelectorAll(`[data-range-filter="${type}"]`)];
    return definitions.find((definition) => definition.dataset.rangeBucketed === 'true') || definitions[0];
  }

  function rangeInputs(form, type) {
    const definition = rangeDefinition(form, type);
    return {
      min: definition?.querySelector(`[data-range-min="${type}"]`),
      max: definition?.querySelector(`[data-range-max="${type}"]`),
    };
  }

  function parseBound(rawValue, bucketed, upperBound) {
    if (!rawValue) return { value: null, error: '' };

    const value = Number(rawValue);
    if (!Number.isFinite(value) || value < 0) {
      return { value: null, error: 'Enter a nonnegative number.' };
    }
    const bucketValue = upperBound ? Math.ceil(value) : Math.floor(value);
    return { value: bucketed ? bucketValue : value, error: '' };
  }

  function applyRangeToSearchParams(form, searchParams) {
    let isValid = true;
    RANGE_TYPES.forEach((type) => {
      const definition = rangeDefinition(form, type);
      const { min: minInput, max: maxInput } = rangeInputs(form, type);
      if (!definition || !minInput || !maxInput) return;

      const paramName = definition.dataset.rangeParam;
      const min = minInput.value.trim();
      const max = maxInput.value.trim();
      const upperBoundIsExclusive = definition.dataset.rangeBucketed === 'true';
      searchParams.delete(paramName);
      searchParams.delete(rangeStateKey(type, 'min'));
      searchParams.delete(rangeStateKey(type, 'max'));
      minInput.setCustomValidity('');
      maxInput.setCustomValidity('');

      if (!min && !max) return;

      const parsedMin = parseBound(min, upperBoundIsExclusive, false);
      const parsedMax = parseBound(max, upperBoundIsExclusive, true);
      const hasInvalidBounds = parsedMin.value !== null && parsedMax.value !== null && parsedMax.value <= parsedMin.value;
      const validationMessage = parsedMin.error || parsedMax.error || (
        hasInvalidBounds
          ? 'To must be greater than From.'
          : ''
      );

      minInput.setCustomValidity(validationMessage);
      maxInput.setCustomValidity(validationMessage);
      if (validationMessage) {
        (parsedMin.error ? minInput : maxInput).reportValidity();
        isValid = false;
        return;
      }

      const values = (definition.dataset.rangeValues || '').split(',');
      const lowerBound = parsedMin.value ?? Number.NEGATIVE_INFINITY;
      const upperBound = parsedMax.value ?? Number.POSITIVE_INFINITY;

      values.forEach((value) => {
        const numericValue = Number(value);
        if (!Number.isFinite(numericValue) || (upperBoundIsExclusive && !Number.isInteger(numericValue))) return;
        const belowUpperBound = upperBoundIsExclusive ? numericValue < upperBound : numericValue <= upperBound;
        if (numericValue >= lowerBound && belowUpperBound) {
          searchParams.append(paramName, value);
        }
      });

      if (min) searchParams.set(rangeStateKey(type, 'min'), String(parsedMin.value));
      if (max) searchParams.set(rangeStateKey(type, 'max'), String(parsedMax.value));
    });
    return isValid;
  }

  function restoreRangeInputs() {
    const params = new URLSearchParams(window.location.search);
    document.querySelectorAll('facet-filters-form form').forEach((form) => {
      RANGE_TYPES.forEach((type) => {
        const { min, max } = rangeInputs(form, type);
        if (!min || !max) return;
        min.value = params.get(rangeStateKey(type, 'min')) || '';
        max.value = params.get(rangeStateKey(type, 'max')) || '';
      });
    });
  }

  function rangeRemovalUrl(type, paramName) {
    const params = new URLSearchParams(window.location.search);
    params.delete(paramName);
    params.delete(rangeStateKey(type, 'min'));
    params.delete(rangeStateKey(type, 'max'));
    const query = params.toString();
    return `${window.location.pathname}${query ? `?${query}` : ''}`;
  }

  function injectRangeChips() {
    const params = new URLSearchParams(window.location.search);
    document.querySelectorAll('[data-range-chip]').forEach((chip) => chip.remove());

    const definitions = new Map();
    document.querySelectorAll('[data-range-filter]').forEach((definition) => {
      const type = definition.dataset.rangeFilter;
      const existing = definitions.get(type);
      if (!existing || definition.dataset.rangeBucketed === 'true') definitions.set(type, definition);
    });

    definitions.forEach((definition, type) => {
      const paramName = definition.dataset.rangeParam;
      const min = params.get(rangeStateKey(type, 'min')) || '';
      const max = params.get(rangeStateKey(type, 'max')) || '';
      if (!min && !max) return;

      const labelName = `${type.charAt(0).toUpperCase()}${type.slice(1)}`;
      const isBucketed = definition.dataset.rangeBucketed === 'true';
      const label = isBucketed
        ? `${labelName}: ${min || '0'}${max ? ` to ${max}` : ' and above'}`
        : `${labelName}: ${min || '0'} - ${max || 'Any'}`;
      document.querySelectorAll('.active-facets.active-facets-desktop, .active-facets-mobile').forEach((container) => {
        const chip = document.createElement('facet-remove');
        chip.dataset.rangeChip = type;

        const link = document.createElement('a');
        link.href = rangeRemovalUrl(type, paramName);
        link.className = 'active-facets__button active-facets__button--light';
        link.innerHTML = `<span class="active-facets__button-inner button button--tertiary">${label}<span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-close-small" viewBox="0 0 12 12"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.5"/></svg></span><span class="visually-hidden">Clear filter</span></span>`;
        link.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          const form = link.closest('facet-filters-form') || document.querySelector('facet-filters-form');
          if (form && typeof form.onActiveFilterClick === 'function') form.onActiveFilterClick(event);
        });
        chip.appendChild(link);
        container.prepend(chip);
      });
    });
  }

  FacetFiltersFormClass.prototype.createSearchParams = function (form) {
    const searchParams = new URLSearchParams(originalCreateSearchParams.call(this, form));
    if (!applyRangeToSearchParams(form, searchParams)) return searchParams.toString();
    return searchParams.toString();
  };

  function searchParamsForNavigation(form) {
    const searchParams = new URLSearchParams(window.location.search);
    const formFieldNames = new Set(
      [...form.elements]
        .map((element) => element.name)
        .filter(Boolean)
    );
    formFieldNames.forEach((name) => searchParams.delete(name));

    const facetForm = form.closest('facet-filters-form');
    if (facetForm) {
      const formParams = new URLSearchParams(originalCreateSearchParams.call(facetForm, form));
      formParams.forEach((value, name) => searchParams.append(name, value));
    }

    return searchParams;
  }

  function syncRangeFilters() {
    restoreRangeInputs();
    injectRangeChips();
    syncMobileFacetBadge();
  }

  function syncMobileFacetBadge() {
    const form = document.getElementById('FacetFiltersFormMobile');
    const badge = document.querySelector('[data-mobile-facets-count]');
    if (!form || !badge) return;

    const checkedCount = form.querySelectorAll('input[type="checkbox"]:checked').length;
    const rangeCount = [...form.querySelectorAll('[data-range-filter]')].filter((definition) =>
      [...definition.querySelectorAll('input[data-range-min], input[data-range-max]')].some(
        (input) => input.value.trim()
      )
    ).length;
    const priceCount = [...form.querySelectorAll('price-range input')].some((input) => input.value.trim()) ? 1 : 0;
    const count = checkedCount + rangeCount + priceCount;

    badge.textContent = count;
    badge.hidden = count === 0;
    badge.setAttribute('aria-label', `${count} filters selected`);
  }

  function clearMobileFacetForm(form) {
    form.querySelectorAll('input[type="checkbox"]:not(:disabled)').forEach((input) => {
      input.checked = false;
    });
    form.querySelectorAll('[data-range-min], [data-range-max], price-range input').forEach((input) => {
      input.value = '';
    });
    syncMobileFacetBadge();
  }

  function openMobileFacetGroups() {
    document.querySelectorAll('#FacetFiltersFormMobile .mobile-facets__details').forEach((details) => {
      details.setAttribute('open', '');
    });
  }

  document.addEventListener('click', (event) => {
    const mobileOpen = event.target.closest('.mobile-facets__open-wrapper');
    if (mobileOpen && !mobileOpen.closest('.mobile-facets__disclosure')?.open) {
      requestAnimationFrame(openMobileFacetGroups);
    }

    const mobileApply = event.target.closest('[data-mobile-facets-apply]');
    if (mobileApply) {
      const form = mobileApply.closest('form');
      const facetFiltersForm = mobileApply.closest('facet-filters-form');
      if (!form || !facetFiltersForm) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      facetFiltersForm.submitFacetForm(form, event);
      mobileApply.closest('.mobile-facets__wrapper')?.querySelector('summary')?.click();
      return;
    }

    const mobileClear = event.target.closest('[data-mobile-facets-clear]');
    if (mobileClear) {
      const form = mobileClear.closest('form');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      clearMobileFacetForm(form);
      return;
    }

    const rangeApply = event.target.closest('[data-range-navigation-apply]');
    if (rangeApply) {
      const form = rangeApply.closest('form');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const searchParams = searchParamsForNavigation(form);
      if (!applyRangeToSearchParams(form, searchParams)) return;

      const query = searchParams.toString();
      window.location.assign(`${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);
      return;
    }

    const option = event.target.closest('[data-catalog-sort-option]');
    if (!option) return;

    const control = option.closest('[data-catalog-sort]');
    const select = control?.querySelector('select[name="sort_by"]');
    if (!select) return;

    select.value = option.dataset.catalogSortOption;
    control.querySelector('.catalog-sort__current').textContent = option.textContent.trim();
    control.querySelectorAll('[data-catalog-sort-option]').forEach((item) => {
      const isCurrent = item === option;
      item.classList.toggle('catalog-sort__option--current', isCurrent);
      item.toggleAttribute('aria-current', isCurrent);
    });
    const facetFiltersForm = select.closest('facet-filters-form');
    const form = select.closest('form');

    if (facetFiltersForm?.dataset.applyFilters === 'true') {
      form?.requestSubmit();
    } else {
      select.dispatchEvent(new Event('input', { bubbles: true }));
    }
    control.querySelector('details')?.removeAttribute('open');
  }, true);

  document.addEventListener('input', (event) => {
    if (event.target.closest('#FacetFiltersFormMobile')) syncMobileFacetBadge();
    if (event.target.closest('[data-range-filter]')) event.stopPropagation();
  }, true);

  // Cached facet renders dispatch before Dawn updates the URL, so wait one frame
  // before reading the query string that stores the custom range state.
  document.addEventListener('facets:updated', () => requestAnimationFrame(syncRangeFilters));
  syncRangeFilters();
})();
